import CheckCircleIcon from "@svg/new-design/check-circle-icon";
import { FC } from "react";

type FeatureText = string | { mobile: string; normal: string };

const FeatureItem: FC<{ feature: FeatureText }> = ({ feature }) => {
  const mobileText = typeof feature === "string" ? feature : feature.mobile;
  const normalText = typeof feature === "string" ? feature : feature.normal;

  return (
    <div className="flex items-center gap-1">
      <CheckCircleIcon className="h-5 w-5 md:w-6 md:h-6" />
      <p className="body-sm md:body-md text-fds-secondary md:hidden">
        {mobileText}
      </p>
      <p className="body-sm md:body-md text-fds-secondary hidden md:block">
        {normalText}
      </p>
    </div>
  );
};

export default FeatureItem;
